enum SchedulingMode {
  CONSULTANT = 'consultant',
  FITTER = 'fitter',
  PARTNER_PORTAL_NEO = 'partner-portal-neo',
}

export { SchedulingMode }
